<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-sitemap"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.photo.scopable.title') }}</h1>
      </div>
      <div class='popup__form'>
        <form @submit.prevent="selectSites" class="form" id="selectSiteForm">
          <div v-for="(site, index) in siteList" :key="site.id">
            <input class="userpopup__checkbox-button" type="checkbox" :value="site.id" :id="index" v-model="site.checked">
            <label class="userpopup__checkbox-label u-pointer" :for="index">{{ site.site }}</label>
          </div>
        </form>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="selectSiteForm" @click='close'>{{ $t('popup.photo.scopable.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="selectSiteForm">{{ $t('popup.photo.scopable.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

export default {
  data: function () {
    return {
      siteList: [
        { 'site': 'Edisac.com', 'id': 'COM', 'checked': true },
        { 'site': 'Edisac.be', 'id': 'BE', 'checked': true },
        { 'site': 'Edisac.nl', 'id': 'NL', 'checked': true },
        { 'site': 'Woomen.fr', 'id': 'Woomen', 'checked': false },
        { 'site': 'Cameleon.eu', 'id': 'Cameleon', 'checked': false },
        { 'site': 'Etrier.fr', 'id': 'Etrier', 'checked': false }
      ]
    }
  },
  props: {
    photo: {
      type: File
    },
    brand: {
      type: String
    }
  },
  mixins: [formMixin, toastMixin],
  mounted () {
    if (typeof this.photo.siteList !== 'undefined') this.siteList = this.photo.siteList
    if (this.brand === '742') this.siteList[3].checked = true // Woomen
    if (this.brand === '737') this.siteList[4].checked = true // Cameleon
    if (this.brand === '731') this.siteList[5].checked = true // Etrier
  },
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('photo/SHOW_PHOTO_SCOPABLE_POPUP', false)
    },
    async selectSites () {
      this.photo.siteList = this.siteList

      this.$emit('changeSites', this.photo)
      this.sendSuccessToast(this.$t('feedback-ok.photo.scopable', { sites: this.checkedSites().join() }))
      this.close()
    },
    checkedSites () {
      return this.siteList.reduce((acc, item) => {
        return item.checked === true ? [ ...acc, item.site ] : acc
      }, [])
    }
  }
}
</script>
